import { ladderLocalStorage } from 'components/Ladder';
import { WINDOW_SIZE_CHANGED_FINISH } from 'react/redux/actions/windowSize';
import {
	CHANGE_PREFERRED_GAMES_NAVIGATE,
	TOGGLE_SHOW_MAIN_CHAT_AS_POPUP,
	TOGGLE_SHOW_STREAM_VIEW_ALWAYS
} from '../actions/settings';
import { Dashboard } from "components/Dashboard";

import {
	MATCHMAKING_OPEN,
	MATCHMAKING_CLOSE,
	MATCHMAKING_SHOW_GAMES,
	PREFERRED_GAMES_UPDATE,
	MATCHMAKING_LIST_SORTED_LIST,
	SET_MATCH_MANAGER,
	MATCHMAKING_REFRESH_LOBBY_LIST_BEGIN,
	MATCHMAKING_REFRESH_LOBBY_LIST_FAIL,
	MATCHMAKING_REFRESH_LOBBY_LIST_SUCCESS,
	CHANGE_MATCHMAKING_TAB,
	CURRENT_MATCH_UPDATE,
	RETRIEVE_CURRENT_MATCH_BEGIN,
	RETRIEVE_CURRENT_MATCH_SUCCESS,
	RETRIEVE_CURRENT_MATCH_FAIL,
	VIEW_GAME_ACTIVITY_FAIL,
	VIEW_GAME_ACTIVITY_SUCCESS,
	VIEW_GAME_ACTIVITY_BEGIN,
	OPENED_MATCH_POPUP,
	CLOSED_MATCH_POPUP,
	MATCHMAKING_SEARCH_MISSED,
	MATCHMAKING_SEARCH_MISSED_CLEAR,
	MATCHMAKING_HAS_CHALLENGE_WAITING,
	REJECTED_MATCH,
	VIEW_GAME_ACTIVITY_MATCH_LIST_SUCCESS,
	VIEW_GAME_ACTIVITY_MATCH_LIST_BEGIN,
	VIEW_GAME_ACTIVITY_MATCH_LIST_FAIL,
	AUTO_QUEUE_MATCHUP_FOUND,
	AUTO_QUEUE_MATCHUP_EXPIRED_YOU_NO_REPLY,
	AUTO_QUEUE_MATCHUP_EXPIRED_OTHER_PLAYER_NO_REPLY,
	AUTO_QUEUE_ACTIVE_STATUS_SUCCESS, AUTO_QUEUE_ACTIVE_STATUS_BEGIN, AUTO_QUEUE_ACTIVE_STATUS_FAIL,
	SET_ACTIVE_SEARCH_TYPE,
} from '../actions/matchmaking';
import { MatchSounds } from "../../../components/MatchSounds";
import { BrowserNotification } from "../../../components/BrowserNotification";
import { matchSearchListManager } from "../../../components/MatchSearchListManager";
import { isMatchOnlyMode } from 'react/netplay/netplayPageState';

export const possibleTabs = {
	chat: 'chat',
	matchmaking: 'matchmaking',
	battle: 'battle',
	friends: 'friends',
	disputes: 'disputes',
	streams: 'streams',
	match_only_view: 'match_only_view',
	settings: 'settings',
};

function shouldShowStreamView(settings) {
	return settings.showStreamViewTabEvenWhenNotStreaming || !!isMatchOnlyMode();
}

const tabsWhileTiny = (settings) => ({
	[possibleTabs.matchmaking]: true,
	[possibleTabs.battle]: true,
	[possibleTabs.chat]: !isMatchOnlyMode(),
	[possibleTabs.friends]: !isMatchOnlyMode(),
	[possibleTabs.disputes]: true,
	[possibleTabs.match_only_view]: shouldShowStreamView(settings),
	[possibleTabs.settings]: true,
});

const tabsWhileSmall = (settings) => ({
	[possibleTabs.matchmaking]: true,
	[possibleTabs.battle]: true,
	[possibleTabs.chat]: true,
	[possibleTabs.friends]: false,
	[possibleTabs.disputes]: true,
	[possibleTabs.streams]: true,
	[possibleTabs.match_only_view]: shouldShowStreamView(settings),
	[possibleTabs.settings]: true,
});

const tabsWhileMedium = (settings) => ({
	[possibleTabs.matchmaking]: true,
	[possibleTabs.battle]: true,
	[possibleTabs.chat]: !settings.forceChatPlusMatchViewForSmallScreens,
	[possibleTabs.friends]: false,
	[possibleTabs.disputes]: true,
	[possibleTabs.streams]: true,
	[possibleTabs.match_only_view]: shouldShowStreamView(settings),
	[possibleTabs.settings]: true,
});

const tabsWhileLarge = (settings) => ({
	[possibleTabs.matchmaking]: true,
	[possibleTabs.battle]: true,
	[possibleTabs.disputes]: true,
	[possibleTabs.streams]: true,
	[possibleTabs.match_only_view]: shouldShowStreamView(settings),
	[possibleTabs.settings]: true,
});

const initialState = {
	pickingSearchesForGame: null,
	pickingSearchesAgainstPlayer: null,
	showingGameSelections: false,
	showingGameSelectionsReallyHard: false,
	preferredGamesList: null,
	matchSearchListManager: null,
	matchmakingRefreshingLobbyList: false,
	currentMatch: null,
	currentMatchUpdateIndex: 0,
	selectedTab: ladderLocalStorage.getItem('matchmakingSelectedTab', 'matchmaking'),
	displayedTabs: null, //Can vary depending on state (In a match or not in a match, ect)
	tabListToUse: null, //The full available tab list usually based on window size
	retrievingCurrentMatch: false,

	viewingPreferredGameFilterActivity: null,
	viewingPreferredGameFilterActivityLoading: false,
	viewingPreferredGameFilterActivityMatches: null,
	viewingPreferredGameFilterActivityMatchesLoading: false,
	viewingPreferredGameFilterActivityStats: null,
	matchPopupOpen: false,
	searchesMissed: [],
	matchIdsParticipatedIn: {},
	matchesRejected: {},
	autoQueueMatchupPending: {},

	autoQueueServerStatusIsBeingChecked: false,
	autoQueueServerIsActive: false,

	activeSearchType: 'friendlies',
};

function updateDashboardStateBasedOnTab(selectedTab) {
	$(function() {
		Dashboard.body.toggleClass('match_only_view', selectedTab === 'match_only_view');
	});
}

updateDashboardStateBasedOnTab(initialState.selectedTab);

export default (state = initialState, action) => {
	switch(action.type) {
		case AUTO_QUEUE_ACTIVE_STATUS_SUCCESS: {
			return {
				...state,
				autoQueueServerStatusIsBeingChecked: true,
				autoQueueServerIsActive: true
			};
		}
		case AUTO_QUEUE_ACTIVE_STATUS_BEGIN: {
			return {
				...state,
				autoQueueServerStatusIsBeingChecked: true,
			};
		}
		case AUTO_QUEUE_ACTIVE_STATUS_FAIL: {
			return {
				...state,
				autoQueueServerStatusIsBeingChecked: false,
				autoQueueServerIsActive: false
			};
		}
		case AUTO_QUEUE_MATCHUP_FOUND:
		case AUTO_QUEUE_MATCHUP_EXPIRED_OTHER_PLAYER_NO_REPLY:
		case AUTO_QUEUE_MATCHUP_EXPIRED_YOU_NO_REPLY: {
			const autoQueueMatchupPending = { ...state.autoQueueMatchupPending };
			const currentMatchesUpdatedState = action.payload;
			const currentMatchesPreviousState = autoQueueMatchupPending[currentMatchesUpdatedState.match_id];
			autoQueueMatchupPending[currentMatchesUpdatedState.match_id] = currentMatchesUpdatedState;
			if(!currentMatchesPreviousState || (!currentMatchesPreviousState.waiting || !currentMatchesPreviousState.expiration)) {
				if(!currentMatchesUpdatedState.waiting && currentMatchesUpdatedState.expiration) {
					const currentMatch = matchSearchListManager.findMatchById(currentMatchesUpdatedState.match_id);
					if(currentMatch) {
						currentMatch.showAutoQueueMatchFoundNotification();
					}
				}
			}

			return {
				...state,
				autoQueueMatchupPending,
			};
		}
		case MATCHMAKING_HAS_CHALLENGE_WAITING: {
			return {
				...state,
				matchmakingHasChallenge: action.payload
			};
		}
		case MATCHMAKING_SEARCH_MISSED_CLEAR: {
			return {
				...state,
				searchesMissed: initialState.searchesMissed,
			};
		}
		case MATCHMAKING_SEARCH_MISSED: {
			const searchesMissed = [...state.searchesMissed];
			const match = action.payload;
			const found = searchesMissed.findIndex((search) => {
				return search.id === match.id;
			});
			if(found === -1) {
				searchesMissed.push(match);
				return {
					...state,
					searchesMissed
				};
			}
			return state;
		}
		case REJECTED_MATCH: {
			const matchesRejected = { ...state.matchesRejected };
			matchesRejected[action.payload] = true;
			return {
				...state,
				matchesRejected,
			};
		}
		case CLOSED_MATCH_POPUP:
			return {
				...state,
				matchPopupOpen: false
			};
		case OPENED_MATCH_POPUP:
			return {
				...state,
				matchPopupOpen: true
			};
		case CHANGE_PREFERRED_GAMES_NAVIGATE:
			return {
				...state,
				selectedTab: possibleTabs.settings
			};
		case RETRIEVE_CURRENT_MATCH_BEGIN:
			return {
				...state,
				retrievingCurrentMatch: true,
			};
		case RETRIEVE_CURRENT_MATCH_SUCCESS:
		case RETRIEVE_CURRENT_MATCH_FAIL:
			return {
				...state,
				retrievingCurrentMatch: false,
			};
		case CURRENT_MATCH_UPDATE: {
			const match = action.payload;
			const newState = {
				...state,
				currentMatch: match,
				currentMatchUpdateIndex: state.currentMatchUpdateIndex + 1
			};
			if(match) {
				newState.matchmakingHasChallenge = false;
			}
			if(match && !state.matchIdsParticipatedIn[match.id]) {
				const matchIdsParticipatedIn = { ...state.matchIdsParticipatedIn };
				matchIdsParticipatedIn[match.id] = true;
				newState.matchIdsParticipatedIn = matchIdsParticipatedIn;
			}
			if(!state.currentMatch && match && state.selectedTab !== possibleTabs.match_only_view) {
				newState.selectedTab = possibleTabs.battle;
				// Play jingles and such
				match.showMatchStartedNotification();
			}
			return newState;
		}
		case WINDOW_SIZE_CHANGED_FINISH: {
			const windowState = action.payload;
			const {
				windowSizeIsLarge,
				windowSizeIsMedium,
				windowSizeIsSmall,
				windowSizeIsTiny,
				settings
			} = windowState;

			let tabListToUse = null;
			if(windowSizeIsLarge) {
				tabListToUse = tabsWhileLarge(settings);
			} else if(windowSizeIsMedium) {
				tabListToUse = tabsWhileMedium(settings);
			} else if(windowSizeIsSmall) {
				tabListToUse = tabsWhileSmall(settings);
			} else if(windowSizeIsTiny) {
				tabListToUse = tabsWhileTiny(settings);
			}

			const newState = {
				...state,
				tabListToUse
			};
			if(!tabListToUse[state.selectedTab]) { //Tab is not visible in the current list!
				if(state.selectedTab === possibleTabs.chat) {
					newState.selectedTab = possibleTabs.matchmaking;
				}

			}
			return newState;
		}
		case CHANGE_MATCHMAKING_TAB:
			ladderLocalStorage.setItem('matchmakingSelectedTab', action.payload);
			updateDashboardStateBasedOnTab(action.payload);
			return {
				...state,
				selectedTab: action.payload
			};
		case SET_MATCH_MANAGER:
			return {
				...state,
				matchSearchListManager: action.payload
			};
		case PREFERRED_GAMES_UPDATE:
			return {
				...state,
				preferredGamesList: action.payload
			};
		case MATCHMAKING_LIST_SORTED_LIST: {
			const { name, list } = action.payload;
			const listName = `matchmakingList${name}`;
			const currentList = state[listName] || [];

			let isSame = false;
			if(list.length === currentList.length) {
				isSame = true;
				for(let id of currentList) {
					if(!list.has(id)) {
						isSame = false;
						break;
					}
				}
			}
			if(isSame) {
				return state;
			}
			const newState = {
				...state
			};
			newState[listName] = [...list.keys()];
			return newState;
		}
		case MATCHMAKING_REFRESH_LOBBY_LIST_FAIL:
			return {
				...state,
				matchmakingRefreshingLobbyList: false,
			};
		case MATCHMAKING_REFRESH_LOBBY_LIST_SUCCESS:
			return {
				...state,
				matchmakingRefreshingLobbyList: false,
			};
		case MATCHMAKING_REFRESH_LOBBY_LIST_BEGIN:
			return {
				...state,
				matchmakingRefreshingLobbyList: true
			};
		case MATCHMAKING_SHOW_GAMES:
			if(state.showingGameSelections === true) {
				return {
					...state,
					showingGameSelectionsReallyHard: true
				};
			}
			return {
				...state,
				showingGameSelections: true
			};
		case MATCHMAKING_OPEN:
			// require('components/Dashboard').Dashboard.matchmakingTab.trigger('activate'); Not sure entirely why this is here...
			return {
				...state,
				pickingSearchesForGame: action.payload.game,
				pickingSearchesAgainstPlayer: action.payload.player,
			};
		case MATCHMAKING_CLOSE:
			return {
				...state,
				pickingSearchesForGame: null,
				pickingSearchesAgainstPlayer: null,
				showingGameSelectionsReallyHard: false,
				viewingPreferredGameFilterActivity: null,
			};
		case VIEW_GAME_ACTIVITY_BEGIN:
			return {
				...state,
				viewingPreferredGameFilterActivity: action.payload,
				viewingPreferredGameFilterActivityLoading: true,
				viewingPreferredGameFilterActivityStats: null,
				viewingPreferredGameFilterActivityMatches: null,
				viewingPreferredGameFilterActivityMatchesLoading: true,
			};
		case VIEW_GAME_ACTIVITY_SUCCESS:
			const updates = {};
			if(action.payload.stats) {
				updates.viewingPreferredGameFilterActivityStats = action.payload.stats;
			}
			return {
				...state,
				viewingPreferredGameFilterActivityLoading: false,
				...updates,
			};
		case VIEW_GAME_ACTIVITY_FAIL:
			return {
				...state,
				viewingPreferredGameFilterActivityLoading: false,
				viewingPreferredGameFilterActivityError: true,
			};
		case VIEW_GAME_ACTIVITY_MATCH_LIST_BEGIN:
			return {
				...state,

			};
		case VIEW_GAME_ACTIVITY_MATCH_LIST_SUCCESS:
			return {
				...state,
				viewingPreferredGameFilterActivityMatches: action.payload.matches,
				viewingPreferredGameFilterActivityMatchesLoading: false,
			};
		case VIEW_GAME_ACTIVITY_MATCH_LIST_FAIL:
			return {
				...state,
				viewingPreferredGameFilterActivityMatchesLoading: false,
			};
		case SET_ACTIVE_SEARCH_TYPE:
			return {
				...state,
				activeSearchType: action.searchType,
			};
		default:
			return state;
	}
}